<template>
  <tr>
    <td><username :user="user" /></td>
    <td>{{ user.name }}</td>
    <td v-if="$auth.check('admin')">{{ user.email }}</td>
    <td v-if="user.role !== 'user'">{{ user.role }}</td>
    <td v-else-if="!user.banned">user</td>
    <td v-else-if="user.banned && !user.banned_until">permabanned user</td>
    <td v-else>
      tempbanned user
      <br />
      <small>until {{ user.banned_until }}</small>
    </td>
    <td class="text-lg flex justify-center">
      <a
        class="text-green-7 hover:text-green-5 mx-1 cursor-pointer"
        @click="show.edit = true"
        v-if="$auth.check('admin')"
      >
        <edit-icon></edit-icon>
      </a>
      <a
        class="text-yellow-8 hover:text-yellow-6 mx-1 cursor-pointer"
        v-if="user.role === 'user' && !user.banned"
        @click="show.ban = true"
      >
        <lock-icon></lock-icon>
      </a>
      <a
        class="text-yellow-7 hover:text-yellow-5 mx-1 cursor-pointer"
        v-if="user.role === 'user' && user.banned"
        @click="show.unban = true"
      >
        <unlock-icon></unlock-icon>
      </a>
      <a
        class="text-red-7 hover:text-red-5 mx-1 cursor-pointer"
        @click="show.delete = true"
        v-if="$auth.check('admin')"
      >
        <trash2-icon></trash2-icon>
      </a>
    </td>

    <portal to="modal-portal">
      <user-admin-modal
        v-if="show.edit"
        :existing="user"
        @close="show.edit = false"
        @success="success('edit')"
      />
    </portal>

    <portal to="modal-portal">
      <user-admin-ban-form
        v-if="show.ban"
        :existing="user"
        @close="show.ban = false"
        @success="success('ban')"
      />
    </portal>

    <portal to="modal-portal">
      <prompt v-if="show.unban" @close="show.unban = false" @confirm="unban">
        This will unban
        <span class="font-semibold text-blue-8">{{ user.username }}</span>.
        <br />Are you sure?
      </prompt>
    </portal>

    <portal to="modal-portal">
      <prompt v-if="show.delete" @close="show.delete = false" @confirm="deleteUser">
        This will delete
        <span class="font-semibold text-blue-8">{{ user.username }}</span> including all of their threads & replies. This cannot be undone.
        <br />Are you sure?
      </prompt>
    </portal>
  </tr>
</template>

<script>
import UserAdminModal from "@/components/Modals/UserAdminModal"
import UserAdminBanForm from "@/components/Forms/UserAdminBanForm"
import { EventBus } from "@/events"
import { EditIcon, Trash2Icon, LockIcon, UnlockIcon } from "vue-feather-icons"

export default {
  name: "UserAdminRow",
  components: {
    UserAdminModal,
    UserAdminBanForm,
    EditIcon,
    Trash2Icon,
    LockIcon,
    UnlockIcon
  },
  props: {
    user: {
      required: true
    }
  },
  data() {
    return {
      show: {
        edit: false,
        ban: false,
        delete: false,
        unban: false
      }
    }
  },
  methods: {
    success(form) {
      this.show[form] = false
      EventBus.$emit("user:update")
    },
    unban() {
      this.show.unban = false
      this.$api.users
        .unban(this.user.username)
        .then(() => {
          this.$toasted.success("User unbanned.")
          EventBus.$emit("user:update")
        })
        .catch(() => {
          this.$error.generic()
        })
    },
    deleteUser() {
      this.show.delete = false
      this.$api.users
        .destroy(this.user.username)
        .then(() => {
          this.$toasted.success("User deleted.")
          EventBus.$emit("user:update")
        })
        .catch(() => {
          this.$error.generic()
        })
    }
  }
}
</script>
